import { RouteObject } from "react-router-dom";
import { Layout } from "../Layout";
import { Home } from "./home/home";
import { HomeDepartment } from "./homeDepartments/homeDepartment";
import { Register } from "./register/register";
import { Login } from "./login/login";
import { LogoutPage } from "../components/LogoutPage";
import { Verification } from "./register/verification";
import { Transactions } from "./home/transactions";
import { Dashboard } from "./home/dashboard";
import { DepartmentDashboard } from "./homeDepartments/dashboard/departmentDashboard";
import { Vehicles } from "./home/vehicles";
import { CardsAndBadges } from "./home/cardsAndBadges";
import { Rules } from "./home/rules";
import { Users } from "./home/users";
import { Drivers } from "./home/drivers";
import { Billings } from "./home/billings";
import { NotFoundPage } from "../components/NotFoundPage";
import { PasswordForgotten } from "./login/passwordForgotten";
import { PasswordReset } from "./login/passwordReset";
import { RuleCreation } from "./home/rules/ruleCreation";
import { RuleUpdate } from "./home/rules/ruleUpdate";
import { DriverAccessRequest } from "./home/drivers/driversAccessRequest";
import { CompanyCreation } from "./home/companies/companyCreation";
import { PasswordCreation } from "./login/passwordCreation";
import { Fleet } from "./home/fleet";
import { Electrification } from "./home/electrification";
import { Notifications } from "./home/notifications";
import { Geolocation } from "./home/geolocation";
import { DepartmentVehicles } from "./homeDepartments/vehicles";
import { DepartmentTransactions } from "./homeDepartments/transactions";
import { DepartmentDrivers } from "./homeDepartments/drivers";
import { AddUserPage } from "./home/users/modals/addUserPage";
import { DepartmentCardsAndBadges } from "./homeDepartments/cardsAndBadges";
import { DepartmentFleet } from "./homeDepartments/fleet";
import { UpdateUserRolePage } from "./home/users/modals/updateUserRolePage";
import { ImportVehiclesPage } from "./home/vehicles/modals/importVehiclesModal";
import { ExternalBankAccountPage } from "./home/billings/modals/externalBankAccountModal";
import { MemobankMandatePage } from "./home/billings/modals/memobankMandateModal";
import { AddMultipeCardsPage } from "./home/cardsAndBadges/modals/cards/addMulitpleCardsModal";
import { AddMultipeBadgesPage } from "./home/cardsAndBadges/modals/badges/addMulitpleBadgesModal";
import { Departments } from "./home/departments";

export const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      {
        path: "home",
        element: <Home />,
        children: [
          { path: "", element: <Dashboard /> },
          { path: "vehicles/:id?", element: <Vehicles /> },
          { path: "vehicles_import", element: <ImportVehiclesPage /> },
          { path: "cards/:tab?/:id?", element: <CardsAndBadges /> },
          {
            path: "cards_order_multiple_cards",
            element: <AddMultipeCardsPage />,
          },
          {
            path: "cards_order_multiple_badges",
            element: <AddMultipeBadgesPage />,
          },
          { path: "rules", element: <Rules /> },
          { path: "rules/:name", element: <Rules /> },
          { path: "rule_creation/:origin", element: <RuleCreation /> },
          { path: "rule/:id", element: <RuleUpdate /> },
          { path: "users/:tab?/:id?", element: <Users /> },
          { path: "user_creation", element: <AddUserPage /> },
          { path: "user_update_role/:id", element: <UpdateUserRolePage /> },
          { path: "drivers/:id?", element: <Drivers /> },
          {
            path: "drivers/access_request/:id?",
            element: <DriverAccessRequest />,
          },
          { path: "transactions/:tab?/:id?", element: <Transactions /> },
          { path: "billings/:tab?/:sepa_debit?", element: <Billings /> },
          {
            path: "billings_import_external_account",
            element: <ExternalBankAccountPage />,
          },
          {
            path: "billings_mandate_signature_request",
            element: <MemobankMandatePage />,
          },
          { path: "fleet/:tab?/:id?", element: <Fleet /> },
          { path: "electrification/:tab?", element: <Electrification /> },
          { path: "notifications/:tab?", element: <Notifications /> },
          { path: "geolocation", element: <Geolocation /> },
          { path: "departments/:id?", element: <Departments /> },
        ],
      },
      {
        path: "departments",
        element: <HomeDepartment />,
        children: [
          { path: "", element: <DepartmentDashboard /> },
          { path: "vehicles/:id?", element: <DepartmentVehicles /> },
          // add path route
          { path: "cards/:tab?/:id?", element: <DepartmentCardsAndBadges /> },
          {
            path: "transactions/:tab?/:id?",
            element: <DepartmentTransactions />,
          },
          { path: "drivers/:id?", element: <DepartmentDrivers /> },
          {
            path: "drivers/access_request/:id?",
            element: <DriverAccessRequest />,
          },
          { path: "fleet/:tab?/:id?", element: <DepartmentFleet /> },
        ],
      },
      {
        path: "login",
        element: <Login />,
      },
      { path: "logout", element: <LogoutPage /> },
      {
        path: "register",
        element: <Register />,
      },
      {
        path: "verification",
        element: <Verification />,
      },
      {
        path: "password_forgotten",
        element: <PasswordForgotten />,
      },
      {
        path: "password_reset",
        element: <PasswordReset />,
      },
      {
        path: "*",
        element: <NotFoundPage />,
      },
      {
        path: "new_company",
        element: <CompanyCreation />,
      },
      {
        path: "new_password/:id",
        element: <PasswordCreation />,
      },
    ],
  },
];
